<template>
  <div>
    <div class="editBread">
      <a-breadcrumb>
        <a-breadcrumb-item class="cp" @click="jumpPage"
          >导航配置管理</a-breadcrumb-item
        >
        <a-breadcrumb-item><a href="">编辑导航</a></a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="EditContainer mb100">
      <a-tabs
        v-model:activeKey="activePeopleType"
        @change="changeActivePeopleType"
        hide-add
        type="editable-card"
        @edit="onEdit"
      >
        <a-tab-pane :key="2" tab="ALL" :closable="false"></a-tab-pane>
        <a-tab-pane
          :key="14"
          tab="Local Sale"
          force-render
          v-if="localVisible"
        ></a-tab-pane>
        <template #rightExtra>
          <a-popconfirm
            title="是否同步all人群菜单配置?"
            ok-text="同步"
            cancel-text="取消"
            @confirm="addLocal"
            @cancel="cancel"
          >
            <a-button type="link" v-if="dataAll?.length !== 2"
              >添加人群</a-button
            >
          </a-popconfirm>
        </template>
      </a-tabs>
      <div class="w200 mb10">
        <div class="mb4"><span class="red">*</span>导航名称：</div>
        <a-input
          @change="
            () =>
              postParams.subChannel - 0 === 2
                ? undefined
                : inputLengthCut({ val: postParams.navName, len: 100, type: 1 })
          "
          v-model:value="postParams.navName"
          placeholder="请输入导航名称"
        />
      </div>
      <div class="w200 mb10" v-if="postParams.terminalId - 0 !== 2">
        <div class="mb4">导航类型：</div>
        <a-radio-group
          :disabled="
            Boolean(postParams.id) ||
              !!menuList.length ||
              activePeopleType === 14
          "
          :options="typeOptions"
          @change="e => changeNavType(e, 'navType')"
          v-model:value="postParams.navType"
        />
      </div>
      <div class="w200 mb10" v-if="postParams.terminalId - 0 !== 2">
        <div class="mb4">适配终端：</div>
        <a-radio-group
          :disabled="
            Boolean(postParams.id) ||
              !!menuList.length ||
              activePeopleType === 14
          "
          v-model:value="postParams.subChannel"
          @change="e => changeNavType(e, 'subChannel')"
        >
          <a-radio v-if="postParams.subChannel !== -1" :value="1">PC端</a-radio>
          <a-radio v-if="postParams.subChannel !== -1" :value="2">M端</a-radio>
          <a-radio v-if="postParams.subChannel === -1" :value="-1">APP</a-radio>
        </a-radio-group>
      </div>
      <div
        class="w400 mb10"
        v-if="postParams.navType === 'header' && postParams.subChannel === 2"
      >
        <div class="mb4">导航样式：</div>
        <a-radio-group
          :disabled="
            Boolean(postParams.id) ||
              !!menuList.length ||
              activePeopleType === 14
          "
          :options="styleOptions"
          v-model:value="postParams.navStyle"
          @change="navStyleChange"
        />
      </div>
      <div class="mb10">
        <div class="mb10">菜单配置：</div>
        <MenuSet />
      </div>
    </div>
  </div>
  <div class="bottomBar">
    <!-- <a-button type="default" class="fl">预览</a-button> -->
    <div class="fr">
      <a-button type="default" class="mr10" @click="() => jumpPage()"
        >取消</a-button
      >
      <a-button type="primary" @click="() => saveOrEditNav()">保存</a-button>
    </div>
  </div>
  <MenuDrawer />
  <ColModal />
</template>
<script>
import MenuSet from './components/MenuSet.vue'
import MenuDrawer from './components/MenuDrawer.vue'
import ColModal from './components/ColModal.vue'
import { reactive, toRefs, onMounted, provide, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import useAPI from 'UseApi'
import { message } from 'ant-design-vue'
import { formRequest } from 'cupshe-axios'
const {
  nav_col_list_post_,
  nav_v2_save_post_,
  // nav_detail_id_get_,
  nav_v2_detail_id_get_,
  common_lang_get_,
  nav_v2_people_types_get_
} = useAPI(null, [5390, 3426, 7741])
export default {
  components: {
    MenuSet,
    MenuDrawer,
    ColModal
  },
  setup() {
    function resetId(menuList) {
      return menuList.map(item => ({
        ...item,
        id: null,
        menuList: item.menuList ? resetId(item.menuList) : []
      }))
    }
    const sortAppLevel3 = list => {
      return list.sort((a, b) => {
        const getScore = item => {
          if (+item.menuType === 101) {
            if (item.bannerType === 1) return -1 // Header
            if (item.bannerType === 2) return 1 // Footer
          }
          return 0 // Normal
        }
        return getScore(a) - getScore(b)
      })
    }
    const route = useRoute()
    const state = reactive({
      dataAll: [],
      activePeopleType: 2,
      localVisible: false,
      changeNavType: (e, key) => {
        if (state.dataAll?.length === 2) {
          state.dataAll[1][key] = e.target.value
        }
      },
      changeActivePeopleType: async e => {
        console.log('e ', e)
        if (e - 0 === 2) {
          // all
          state.dataAll[1] = {
            ...state.postParams,
            menuList: state.menuList,
            peopleType: 14
          }
        } else {
          // localSale
          state.dataAll[0] = {
            ...state.postParams,
            menuList: state.menuList,
            peopleType: 2
          }
        }
        state.navSetParams(e)
      },
      onEdit: () => {
        state.localVisible = false
        state.activePeopleType = 2
        state.dataAll?.length === 2 && state.dataAll.splice(1, 1)
        state.navSetParams(2)
      },
      addLocal: () => {
        // state.navSetParams(-1)
        state.dataAll[1] = {
          ...state.postParams,
          menuList: resetId(state.menuList),
          id: null,
          peopleType: 14
        }
        state.localVisible = true
      },
      navSetParams: (e = 2) => {
        const {
          menuList,
          navName,
          navType,
          subChannel,
          id,
          navStyle
        } = state.dataAll[e === 2 ? 0 : 1]
        state.menuList = menuList
        if (state.menuList.length) {
          state.checkIndex = 0
          if (state.menuList[state.checkIndex].menuList.length) {
            state.sonCheckIndex = 0
          }
        }
        state.postParams = {
          ...state.postParams,
          id,
          menuList,
          navName,
          navType,
          navStyle,
          subChannel: subChannel - 0,
          peopleType: e
        }
      },
      params: {
        token: null, //用户Token
        bakPictureColor: '#000000', // countdownColor背景图片色值
        brandId: 1, //品牌Id
        channelId: 1, //渠道Id
        countdownBakColor: '#000000', //countdownColor倒计时背景色值
        countdownColor: '#000000', //countdownColor倒计时时间色值
        countdownCopywritingColor: '#000000', // countdownCopywritingColor倒计时文案色值
        countdownType: 0, // 倒计时类型。0-不对客，1-自定义倒计时，2-读取优惠券
        ouponCode: '', //优惠券编码
        currency: null, // 币种
        displayTime: new Date(), // 倒计时显示限制
        endTime: new Date(), //	活动结束时间
        id: null, // 倒计时配置id
        imageUrl: '', // imageUrl活动图片url
        lang: '',
        langCode: '',
        siteId: 1,
        startTime: new Date(), //活动开始时间
        terminalId: 1,
        title: '', //	标题
        titleColor: '#000000', // titleColor标题色值
        toEndCopywriting: '' //toEndCopywriting距结束文案
      },
      common_lang_get: async () => {
        await common_lang_get_({ ...state.route.query }, state)
        state.menu.langs = state.langDic.map(({ value, label }) => ({
          langCode: value,
          langLabel: label,
          menuPic: null,
          menuName: null,
          menuPicDtos: []
        }))
        // const langs = []
        // for (let i = 0; i < state.langDic.length; i++) {
        //   langs.push({
        //     langCode: state.langDic[i].value,
        //     langLabel: state.langDic[i].label,
        //     menuPic: null,
        //     menuName: null
        //   })
        // }
        // state.menu.langs = [...langs]
      },
      langCode: null,
      langDic: [],
      addonBeforeVisible: false,
      addonPagination: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页的数量
        total: 0 // 总记录数
      },
      banner: null,
      syncData: (data, index) => {
        if (state.menu.menuCategory === 2) {
          const item = data?.[0].menuPicDtos?.[index]
          data.forEach((menu, i) => {
            if (i !== 0) {
              console.log('menu ', menu)
              menu.menuPicDtos[index] = {
                ...menu.menuPicDtos[index],
                addonBefore: item.addonBefore ? item.addonBefore : '',
                menuUrl: item.menuUrl ? item.menuUrl : '',
                urlType: item.urlType,
                colId: item.colId
              }
            }
          })
        }
        if (state.banner) {
          const item = state.banner
          state.langDic.forEach((menu, i) => {
            if (i !== 0 && menu.menuPicDtos?.[index]) {
              const target = menu.menuPicDtos[index]
              target.addonBefore = item.addonBefore || ''
              target.menuUrl = item.menuUrl || ''
              target.urlType = item.urlType
              target.colId = item.colId
            }
          })
        }
      },
      syncMenuPicDtos: data => {
        if (!Array.isArray(data) || data.length === 0) {
          console.error('Invalid data format or empty array.')
          return data
        }

        const firstMenuPicDtos = data[0]?.menuPicDtos || []

        if (firstMenuPicDtos.length === 0) {
          console.warn('No menuPicDtos found in the first item.')
          return data
        }
        const { menuUrl, urlType, colId, addonBefore } = firstMenuPicDtos[0]
        return data.map((item, index) => {
          if (
            index > 0 &&
            Array.isArray(item.menuPicDtos) &&
            item.menuPicDtos.length > 0
          ) {
            item.menuPicDtos = item.menuPicDtos.map(dto => ({
              ...dto,
              menuUrl: menuUrl ?? dto.menuUrl,
              urlType: urlType ?? dto.urlType,
              colId: colId ?? dto.colId,
              addonBefore: addonBefore ?? dto.addonBefore
            }))
          }
          return item
        })
      },
      changeMenuUrl: index => {
        console.log('changeMenuUrl', index)
        state.syncData(state.langDic, index)
      },
      picIndex: 0,
      addonBeforeChange: (
        addonBeforeVisible = false,
        text,
        banner = false,
        index
      ) => {
        if (banner) {
          state.banner = banner
          state.picIndex = index
        }
        if (addonBeforeVisible) {
          state.getColList()
        } else {
          state.addonPagination = {
            pageNum: 1, // 当前页
            pageSize: 10, // 每页的数量
            total: 0 // 总记录数
          }
          if (text && state.menu.menuCategory !== 2 && !state.banner) {
            const { colId, fullSeoUrl } = text
            state.menu = { ...state.menu, addonBefore: fullSeoUrl, colId }
            if (state.postParams.subChannel === -1) {
              state.menu = {
                ...state.menu,
                addonBefore: fullSeoUrl,
                colId,
                menuUrl: ''
              }
            }
          }
          if (text && (state.menu.menuCategory === 2 || state.banner)) {
            const { colId, fullSeoUrl } = text
            if (state.banner) {
              state.banner.addonBefore = fullSeoUrl
              state.banner.colId = colId
              state.banner.menuUrl = ''
            }
            state.addonBeforeVisible = addonBeforeVisible
            state.syncData(state.langDic, state.picIndex)
          }
        }
        state.addonBeforeVisible = addonBeforeVisible
        if (!addonBeforeVisible) state.banner = null
      },
      inputLengthCut: (
        { val = '', len = 0, type = 1, menuModule } = {},
        item
      ) => {
        if (state.postParams.subChannel === 2) {
          val = val || ''
          if (type === 1) {
            state.postParams.navName = val
            return
          }
          if (type === 2) {
            state.menu.menuName = val
            if (item) item.menuName = val
            return
          }
        }
        if (menuModule === 2 && route.query.terminalId !== '2') {
          // eslint-disable-next-line no-misleading-character-class
          const emojiRegex = /[\uD83C-\uDBFF\uDC00-\uDFFF\u200D\u2640-\u2642\u2702-\u27B0\u24C2\u2B50\u231A\u2328\u25AA\u25FE\u2B06\u2194\u21AA\u2B05\u27A1\u21A9\u2B05\ufe0f]+/
          if (emojiRegex.test(val)) {
            item.menuName = item.menuName.replace(
              // eslint-disable-next-line no-misleading-character-class
              /[\uD83C-\uDBFF\uDC00-\uDFFF\u200D\u2640-\u2642\u2702-\u27B0\u24C2\u2B50\u231A\u2328\u25AA\u25FE\u2B06\u2194\u21AA\u2B05\u27A1\u21A9\u2B05\ufe0f]+/g,
              ''
            )
            return message.error('导航名称不能包含表情符号')
          }
        }
        val = val || ''
        if (type === 1) {
          let value = val
            .split('')
            .splice(0, len)
            .join('')
          state.postParams.navName = value
        }
        if (type === 2) {
          let value = val
            .split('')
            .splice(0, state.postParams.navType === 'header' ? 30 : 50)
            .join('')
          state.menu.menuName = value
          if (item) {
            item.menuName = value
          }
        }
      },
      upload: (info = null, item, index = -1) => {
        state.uploadErr = null
        state.fileList = [info.file]
        state.info = info
        state.uploadHandleChange(item, index)
      },
      uploadSecondMenu: (info = null, item, index = -1) => {
        state.uploadErr = null
        state.info = info
        state.uploadHandleSecondChange(item, index)
      },
      deletePic: (item, index, langDic) => {
        // item.menuPicDtos.splice(index, 1)
        langDic.forEach(dic => {
          dic.menuPicDtos.splice(index, 1)
        })
      },
      clearBannerPic: (index, langDic) => {
        langDic.forEach(dic => {
          if (dic.menuPicDtos && dic.menuPicDtos[index]) {
            const item = dic.menuPicDtos[index]
            item.picUrl = ''
            item.picName = ''
            item.externalMaterialId = ''
            item.externalMaterialSource = ''
          }
        })
      },
      beforeUpload: async (
        file,
        item,
        isMainLanguage,
        langDic,
        type,
        element
      ) => {
        const isJpgOrPng =
          file.type === 'image/jpeg' || file.type === 'image/png'
        if (!isJpgOrPng) {
          return message.error('请上传格式为JPG、PNG的图片')
        }
        let fileSize = 0.5
        // if (props.bannerItem.size) {
        //   fileSize = props.bannerItem.size
        // }
        const shSize = fileSize * 1000
        const isSize = file.size / 1024 > shSize
        if (isSize) {
          return message.error(`上传的图片不能大于${shSize}kb`)
        }
        let isSizes = false
        let bannerItem =
          type - 0 === 1
            ? { width: 295, height: 80 }
            : { width: 295, height: 148 }
        isSizes = await state
          .isSizeList(file, bannerItem.width / bannerItem.height)
          .catch(() => {
            isSizes = false
          })
        if (!isSizes) {
          return message.error('图片比例不正确')
        }
        state.handleUpload(file, item, isMainLanguage, langDic, element)
        return Promise.reject()
      },
      onDragEnd: () => {
        const sortOrder = state.langDic[0].menuPicDtos.map(item => item.sort)
        const adjustSortOrder = (arr, sortOrder) => {
          return arr.map(item => {
            const sortedMenup = item.menuPicDtos.sort((a, b) => {
              return sortOrder.indexOf(a.sort) - sortOrder.indexOf(b.sort)
            })
            return { menuPicDtos: sortedMenup }
          })
        }
        adjustSortOrder(state.langDic, sortOrder)
      },
      isSizeList: (file, proportion) => {
        return new Promise((resolve, reject) => {
          let _URL = window.URL || window.webkitURL
          let img = new Image()
          img.onload = () => {
            let valid = img.width / img.height === proportion
            valid ? resolve(true) : reject(false)
          }
          img.src = _URL.createObjectURL(file)
        })
      },
      handleUpload: async (
        file,
        item,
        isMainLanguage,
        langDic,
        element = false
      ) => {
        const api = `${process.env.VUE_APP_CMS}/cms/material/upload`
        const { success, data } = await formRequest(api, {
          file
        })
        // file_upload_post({ uploadFile: file })
        if (success) {
          const { url } = data
          if (element) {
            element.picUrl = url
            element.picName = file.name
            element.externalMaterialId = ''
            element.externalMaterialSource = ''
            return
          }
          let params = {}
          if (isMainLanguage) {
            const index = langDic?.[0].menuPicDtos?.length - 1
            const urlType = langDic?.[0]?.menuPicDtos[index]?.urlType
            const colId = langDic?.[0]?.menuPicDtos[index]?.colId
            const menuUrl = langDic?.[0]?.menuPicDtos[index]?.menuUrl
            if (
              (urlType === 0 && !colId) ||
              (urlType === 1 && !menuUrl) ||
              urlType === null
            ) {
              return message.warning('请先上传填写主语言图片链接')
            }
            params = {
              urlType,
              colId: colId,
              menuUrl: menuUrl
            }
          } else {
            langDic.forEach((dic, index) => {
              if (index !== 0) {
                dic.menuPicDtos.push({
                  picName: null,
                  picUrl: null,
                  menuUrl: '',
                  urlType: 1,
                  ...params,
                  sort: item.menuPicDtos?.length + 1,
                  externalMaterialId: '',
                  externalMaterialSource: ''
                })
              }
            })
          }
          if (!item.menuPicDtos?.length) {
            item.menuPicDtos = []
            item.menuPicDtos.push({
              picName: file.name,
              picUrl: url,
              menuUrl: null,
              urlType: 1,
              ...params,
              sort: 1,
              externalMaterialId: '',
              externalMaterialSource: ''
            })
          } else {
            item.menuPicDtos.push({
              picName: file.name,
              picUrl: url,
              menuUrl: null,
              urlType: 1,
              ...params,
              sort: item.menuPicDtos?.length + 1,
              externalMaterialId: '',
              externalMaterialSource: ''
            })
          }
        }
      },
      updateResourceMateral: (file, item, index, isMainLanguage, langDic) => {
        const files = Array.isArray(file) ? file : [file]
        if (!files.length) return

        if (index === -1) {
          files.forEach(f => {
            if (!item.menuPicDtos) item.menuPicDtos = []
            const newSort = item.menuPicDtos.length + 1
            const newItem = {
              picName: f.name,
              picUrl: f.url,
              menuUrl: null,
              urlType: 1,
              sort: newSort,
              externalMaterialId: f.materialNo,
              externalMaterialSource: f.source,
              materialTitle: '',
              isShowTitle: 1
            }
            item.menuPicDtos.push(newItem)

            langDic.slice(1).forEach(lang => {
              if (!lang.menuPicDtos) lang.menuPicDtos = []
              lang.menuPicDtos.push({ ...newItem })
            })
          })
        } else {
          const f = files[0]
          const oldItem = item.menuPicDtos[index] || {}
          item.menuPicDtos[index] = {
            ...oldItem,
            picName: f.name,
            picUrl: f.url,
            // menuUrl: null,
            // urlType: 1,
            sort: oldItem.sort || index + 1,
            externalMaterialId: f.materialNo,
            externalMaterialSource: f.source
          }
          // Sync other languages if it's the default language (isMainLanguage param is false for default lang)
          if (!isMainLanguage && langDic) {
            langDic.forEach((lang, i) => {
              if (i !== 0 && lang.menuPicDtos?.[index]) {
                const target = lang.menuPicDtos[index]
                target.picName = f.name
                target.picUrl = f.url
                target.externalMaterialId = f.materialNo
                target.externalMaterialSource = f.source
              }
            })
          }

          if (files.length > 1) {
            const remainingFiles = files.slice(1)
            remainingFiles.forEach(rf => {
              if (!item.menuPicDtos) item.menuPicDtos = []
              const newSort = item.menuPicDtos.length + 1
              const newItem = {
                picName: rf.name,
                picUrl: rf.url,
                menuUrl: null,
                urlType: 1,
                sort: newSort,
                externalMaterialId: rf.materialNo,
                externalMaterialSource: rf.source,
                materialTitle: '',
                isShowTitle: 1
              }
              item.menuPicDtos.push(newItem)

              langDic.slice(1).forEach(lang => {
                if (!lang.menuPicDtos) lang.menuPicDtos = []
                lang.menuPicDtos.push({ ...newItem })
              })
            })
          }
        }
      },
      syncBannerTitle: (index, key, val) => {
        state.langDic.forEach((lang, i) => {
          if (i !== 0 && lang.menuPicDtos?.[index]) {
            lang.menuPicDtos[index][key] = val
          }
        })
      },
      addBannerRow: () => {
        const item = state.langDic[0] // Main language
        const limit = state.menu.bannerType === 1 ? 3 : 5
        if (item.menuPicDtos?.length >= limit) {
          message.error(`最多上传${limit}张图片`)
          return
        }

        const newRow = {
          picName: '',
          picUrl: '',
          menuUrl: null,
          urlType: 1,
          sort: (item.menuPicDtos?.length || 0) + 1,
          externalMaterialId: '',
          externalMaterialSource: '',
          materialTitle: '',
          isShowTitle: 1
        }

        if (!item.menuPicDtos) item.menuPicDtos = []
        item.menuPicDtos.push(newRow)

        // Sync other languages
        state.langDic.slice(1).forEach(lang => {
          if (!lang.menuPicDtos) lang.menuPicDtos = []
          lang.menuPicDtos.push({ ...newRow })
        })
      },
      uploadHandleSecondChange: async (item, index = null) => {
        const { info } = state
        if (info && info.file) {
          const api = `${process.env.VUE_APP_CMS}/cms/material/upload`
          const { success, retInfo, data } = await formRequest(api, {
            file: info.file
          })
          if (success) {
            const { url } = data
            if (index === -1) {
              const {
                file: { size }
              } = state.info
              let size_ = Math.floor(size / 1024)
              if (size_ > 500) {
                state.uploadErr = '图片大小超过500k，请重新上传！'
                return
              }
              return
            }
            item.menuPics.push({
              picName: info.file.name,
              picUrl: url,
              menuUrl: null
            })
          } else {
            message.error(retInfo)
          }
        } else {
          message.info('文件未上传！')
        }
      },
      uploadHeaders: {
        Authorization:
          localStorage.getItem('token') || '0e044f64c5364f93a5cb83731a09b8b9'
      },
      uploadErr: null,
      uploadHandleChange: async (item, index = null) => {
        const { info } = state
        if (info && info.file) {
          const api = `${process.env.VUE_APP_CMS}/cms/material/upload`
          const { success, retInfo, data } = await formRequest(api, {
            file: info.file
          })
          if (success) {
            const { url } = data
            if (index === -1) {
              const {
                file: { size }
              } = state.info
              let size_ = Math.floor(size / 1024)
              if (size_ > 500) {
                state.uploadErr = '图片大小超过500k，请重新上传！'
                return
              }
              state.uploadErr = null
              state.menu.menuPic = url
              state.menu.externalMaterialId = ''
              state.menu.externalMaterialSource = ''
              item.menuPic = url
              item.externalMaterialId = ''
              item.externalMaterialSource = ''
              return
            }

            state.menuList[state.checkIndex].menuList[index].menuPic = url
          } else {
            message.error(retInfo)
          }
        } else {
          message.info('文件未上传！')
        }
      },
      updateMaterial(info, item, index) {
        state.fileList = [info.file]
        // 用于回显
        state.fileList = [info.url]
        if (index === -1) {
          state.menu.menuPic = info.url
          state.menu.externalMaterialId = info.externalMaterialId
          state.menu.externalMaterialSource = info.externalMaterialSource
          item.menuPic = info.url
          return
        }

        if (state.menuList[state.checkIndex].menuList[index]) {
          state.menuList[state.checkIndex].menuList[index].menuPic = info.url
          state.menuList[state.checkIndex].menuList[index].externalMaterialId =
            info.externalMaterialId
          state.menuList[state.checkIndex].menuList[
            index
          ].externalMaterialSource = info.externalMaterialSource
        }
      },
      // 上传图片
      importProducts: async ({ info }) => {
        const { success, retInfo, data } = await formRequest(
          `${process.env.VUE_APP_COL}/col/importExcel`,
          {
            file: [info.file],
            ...state.route.query
          }
        )
        if (success) {
          let chooseSearchSkcs = data
          chooseSearchSkcs.map(item => (item.search = true))
          state.chooseSearchSkcs = [
            ...state.chooseSearchSkcs,
            ...chooseSearchSkcs
          ]
          message.success(retInfo)
        } else {
          message.error(retInfo)
        }
        state.temList = []
      },
      saveOrEditNav: () => {
        if (state.postParams.subChannel !== -1) {
          state.menuList = state.testHasAddonBefore(state.menuList)
          state.menuList = state.testHasAddonBeforePic(state.menuList)
        }
        if (state.postParams.subChannel === -1) {
          for (let i = 0; i < state.menuList.length; i++) {
            const item = state.menuList[i]
            if (item.subMenuType === 1) {
              if (item.menuList.length % 2 !== 0) {
                message.error(`一级菜单为"常规图文"下的二级菜单数量必须为偶数`)
                return
              }
            }
          }
        }
        state.postParams.versionId = 1
        if (state.activePeopleType === 2) {
          state.dataAll[0] = {
            ...state.postParams,
            peopleType: 2,
            menuList: state.menuList
          }
        } else {
          state.dataAll[1] = {
            ...state.postParams,
            peopleType: 14,
            menuList: state.menuList
          }
        }
        state.dataAll = state.removeExternalMaterialInfo(state.dataAll)
        // nav_save_post_(state)
        nav_v2_save_post_(state)
      },
      testHasAddonBefore: menuList => {
        menuList.map(v => {
          if (!v.addonBefore) {
            let arr = (v?.menuUrl || '')?.split?.('?') || []
            v.addonBefore = arr[0]
            v.menuUrl = arr[1] ? `?${arr[1]}` : undefined
            if (arr.length > 2) {
              v.menuUrl += arr.slice(1).join('?')
            }
          }
          if (!['', null, undefined].includes(v.addonBefore)) {
            if (['', null, undefined].includes(v.menuUrl)) {
              v.menuUrl = v.addonBefore
              v.addonBefore = ''
            } else {
              v.menuUrl = v.addonBefore + v.menuUrl
              v.addonBefore = ''
            }
          }
          if (Array.isArray(v.menuList) && v.menuList.length) {
            state.testHasAddonBefore(v.menuList)
          }
          return v
        })
        return menuList
      },
      testHasAddonBeforePic: menuList => {
        menuList.map(v => {
          if (v.menuCategory === 2) {
            v.langs.map(lang => {
              lang.menuPicDtos = lang.menuPicDtos?.map(pic => ({
                ...pic
              }))
            })
          }
          if (Array.isArray(v.menuList) && v.menuList.length) {
            state.testHasAddonBeforePic(v.menuList)
          }
          return v
        })
        return menuList
      },
      changeBannerType: langDic => {
        langDic.forEach(v => {
          v.menuPicDtos = []
        })
        state.menu.langs = langDic.map(item => ({
          ...item,
          langCode: item.value,
          langLabel: item.label,
          menuPicDtos: []
        }))
      },
      route: useRoute(),
      router: useRouter(),
      jumpPage: () => {
        state.router.push({
          path: 'NavigationNew',
          query: { ...state.route.query }
        })
      },
      getDetail: () => {
        //nav_detail_id_get_(state)
        if (!state.route.query) state.route.query = {}
        state.route.query.versionId = 1
        state.postParams.versionId = 1
        nav_v2_detail_id_get_(state)
        state.common_lang_get(state)
      },
      drawVisible: false,
      postParams: {},
      menuType: 1,
      addOrEdit: 1, // 1 创建 2 编辑
      initLangs: () => {
        let langs = []
        state.langDic.map(v => {
          langs.push({
            langCode: v.value,
            langLabel: v.label,
            menuPic: null,
            menuName: null,
            menuPicDtos: []
          })
        })
        return langs
      },
      dealMenu: (
        drawVisible = false,
        menuType = 1,
        addOrEdit = 1,
        menu,
        menuModule = 1
      ) => {
        if (state.langDic && state.langDic.length) {
          state.langCode = state.langDic[0].value
        }
        if (
          addOrEdit === 1 &&
          menuType === 2 &&
          state.postParams.navType === 'header' &&
          state.postParams.subChannel === 1
        ) {
          const normalCount = (
            state.menuList[state.checkIndex]?.menuList || []
          ).filter(item => item.menuType - 0 !== 101 && item.menuCategory !== 2)
            .length
          if (normalCount >= 5) {
            message.error('二级菜单不可超过5个，请确认')
            return
          }
        }
        if (menu && !menu?.fromColor) {
          menu.fromColor = '#000000'
          menu.toColor = '#000000'
        }
        state.menuType = menuType
        state.addOrEdit = addOrEdit
        if (state.postParams.subChannel === -1) {
          if (menu) {
            menu.urlType = menu.urlType ?? 1
          } else {
            state.resetMenu.urlType = 1
          }
        }
        // 使用深拷贝，防止直接修改 menuList 中的对象
        state.menu =
          addOrEdit === 1
            ? {
                ...state.resetMenu,
                langs: state.initLangs(),
                menuCategory: 1,
                menuModule,
                showName: menuType === 1 ? 0 : 1
              }
            : JSON.parse(JSON.stringify(menu))
        if (
          state.postParams.subChannel === -1 &&
          menuType === 3 &&
          addOrEdit === 1
        ) {
          state.menu.menuType = '100'
        }
        if (menu) {
          let langs = state?.menu?.langs.map(v => {
            return {
              ...v,
              langLabel: state.langDic.find(
                e => String(e.value) === String(v.langCode || v.value)
              )?.label
            }
          })
          if (langs.length === 0) {
            langs = state.langDic.map(({ value, label }) => ({
              langCode: value,
              langLabel: label,
              menuPic: null,
              menuName: null,
              menuPicDtos: []
            }))
          }
          state.menu.langs = langs
          // 强制重置 menuName 和 menuPic 为当前默认语言的内容
          if (state.langDic && state.langDic.length) {
            const defaultLangCode = state.langDic[0].value
            const defaultLang = state.menu.langs.find(
              l => l.langCode === defaultLangCode
            )
            if (defaultLang) {
              state.menu.menuName = defaultLang.menuName
              state.menu.menuPic = defaultLang.menuPic
              state.menu.externalMaterialId = defaultLang.externalMaterialId
              state.menu.externalMaterialSource =
                defaultLang.externalMaterialSource
            }
          }
        } else {
          state.menu.langs = state.langDic.map(({ value, label }) => ({
            langCode: value,
            langLabel: label,
            menuPic: null,
            menuName: null,
            menuPicDtos: []
          }))
          // 强制重置 menuName 和 menuPic 为当前默认语言的内容
          if (state.langDic && state.langDic.length) {
            const defaultLangCode = state.langDic[0].value
            const defaultLang = state.menu.langs.find(
              l => l.langCode === defaultLangCode
            )
            if (defaultLang) {
              state.menu.menuName = defaultLang.menuName
              state.menu.menuPic = defaultLang.menuPic
              state.menu.externalMaterialId = defaultLang.externalMaterialId
              state.menu.externalMaterialSource =
                defaultLang.externalMaterialSource
            }
          }
        }
        console.log('state.menu', state.menu)
        if (state.menu.menuCategory === 2) {
          state.menu.langs?.forEach(v => {
            v.menuPicDtos = v.menuPicDtos?.map((pic, index) => ({
              ...pic,
              sort: index + 1
            }))
          })
        }
        if (state.menu.urlType - 0 === 0) {
          if (drawVisible) {
            if (state.route.query?.id || state.postParams.subChannel === -1) {
              const splitArr = menu?.menuUrl?.split('?') || []
              if (state?.menu?.menuUrl) {
                state.menu.addonBefore = splitArr[0]
                  ? splitArr[0]
                  : state.menu.addonBefore
                state.menu.menuUrl = splitArr[1] ? `?${splitArr[1]}` : ''
                if (splitArr.length > 2) {
                  state.menu.menuUrl += splitArr.slice(1).join('?')
                }
              }
            } else {
              if (!state.route.query?.id) {
                if (menu?.menuUrl?.indexOf('?') > -1) {
                  const splitArr = menu?.menuUrl?.split('?') || []
                  if (state?.menu?.menuUrl) {
                    state.menu.addonBefore = splitArr[0]
                      ? splitArr[0]
                      : state.menu.addonBefore
                    state.menu.menuUrl = splitArr[1] ? `?${splitArr[1]}` : ''
                    if (splitArr.length > 2) {
                      state.menu.menuUrl += splitArr.slice(1).join('?')
                    }
                  }
                } else {
                  // state.menu.addonBefore = menu?.addonBefore ?? ''
                  // state.menu.menuUrl = menu?.menuUrl ?? ''
                }
              }
            }
          } else {
            // state.menu.addonBefore = state.menu.addonBefore //+ '?' + state.menu.menuUrl
            // state.menu.menuUrl = ''
          }
        }
        if (
          state.menu.menuCategory === 2 ||
          (state.postParams.subChannel === -1 && +state.menu.menuType === 101)
        ) {
          state.menu.langs = state.menu.langs.map(v => {
            v.menuPicDtos?.map(pic => {
              if (pic.urlType === 0) {
                const url = (pic.menuUrl || '').split('?')
                pic.addonBefore = url[0]
                pic.menuUrl = url[1] ? '?' + url[1] : ''
              }
              return pic
            })
            return v
          })
        }
        state.langDic = state.langDic.map(v => {
          const findValue = state.menu?.langs.find(
            e => String(e.langCode || e.value) === String(v.value)
          )
          return {
            ...v,
            langCode: v.value,
            ...findValue
          }
        })
        console.log('langDic', state.langDic)
        state.drawVisible = drawVisible
      },
      checkIndex: null,
      sonCheckIndex: null,
      gsCheckIndex: null, // 孙节点
      fourIndex: null,
      checkMenuTab: (checkIndex = null) => {
        state.checkIndex = checkIndex
      },
      showThreeTab: false,
      checkTwoMenuTab: (e, ele) => {
        state.sonCheckIndex = e
        state.showThreeTab = ele?.menuCategory !== 2
      },
      removeMenu: ({ menuType, index, sonIndex, gsIndex, fIndex }) => {
        console.log('sonIndex ', sonIndex)
        switch (menuType) {
          case 1: // 删除一级标题
            state.menuList.splice(index, 1)
            if (state.menuList.length) {
              state.checkIndex = 0
            } else {
              state.checkIndex = null
            }
            state.postParams.modify = true
            break
          case 2: // 删除二级标题
            state.menuList[state.checkIndex].menuList.splice(sonIndex, 1)
            break
          case 3: // 删除三级标题
            sonIndex !== undefined
              ? state.menuList[state.checkIndex].menuList[
                  sonIndex
                ].menuList.splice(gsIndex, 1)
              : state.menuList[state.checkIndex].menuList[
                  state.sonCheckIndex
                ].menuList.splice(gsIndex, 1)
            break
          case 4: // 删除4级标题
            state.menuList[state.checkIndex].menuList[
              state.sonCheckIndex
            ].menuList[gsIndex].menuList.splice(fIndex, 1)
            break
        }
      },
      changemenuCategory: (e, menu, langDic) => {
        if (e.target.value === 2) {
          menu.bannerType = 1
          menu.menuPic = null
          menu.menuUrl = null
          menu.colId = null
          menu.addonBefore = null
          // Reset languages to ensure clean slate for banner
          menu.langs = langDic.map(item => ({
            ...item,
            langCode: item.value,
            langLabel: item.label,
            menuPic: null,
            menuName: item.label === 'English' ? menu.menuName : null, // Preserve English name if available
            menuPicDtos: []
          }))
        } else {
          menu.bannerType = null
          menu.menuUrl = null
          menu.colId = null
          menu.addonBefore = null
          menu.menuPic = null
          // Reset languages to ensure clean slate for text
          menu.langs = langDic.map(item => ({
            ...item,
            langCode: item.value,
            langLabel: item.label,
            menuPic: null,
            menuName: item.label === 'English' ? menu.menuName : null, // Preserve English name if available
            menuPicDtos: []
          }))
          langDic.forEach(v => {
            v.menuPicDtos = []
          })
        }
      },
      changeMenuType: e => {
        const val = e.target.value
        // Common reset
        state.menu.menuUrl = null
        state.menu.colId = null
        state.menu.addonBefore = null
        state.menu.urlType = 0 // Default to Collection
        state.menu.menuName = null
        state.menu.menuPic = null

        if (val === '100') {
          // Text
          state.menu.bannerType = null
        } else {
          // Banner '101'
          state.menu.bannerType = 1
        }

        // Reset languages
        state.menu.langs = state.langDic.map(item => ({
          ...item,
          langCode: item.value,
          langLabel: item.label,
          menuPic: null,
          menuName: null,
          menuPicDtos: [],
          menuUrl: null,
          colId: null,
          addonBefore: null,
          urlType: 0
        }))

        // Sync langDic
        state.langDic.forEach(v => {
          v.menuPicDtos = []
          v.menuPic = null
          v.menuName = null
          v.menuUrl = null
          v.colId = null
          v.addonBefore = null
          v.urlType = 0
        })
      },
      editMenu: menuType => {
        // Sync user inputs from langDic to menu.langs
        state.menu.langs = state.langDic.map(item => ({
          ...item,
          langCode: item.value,
          langLabel: item.label,
          menuPicDtos: item.menuPicDtos || []
        }))

        // Clear menuPic if it is a banner type (App Level 3 Banner)
        if (
          state.postParams.subChannel === -1 &&
          state.menuList[state.checkIndex]?.subMenuType === 1 &&
          +state.menu.menuType === 101
        ) {
          state.menu.langs.forEach(lang => {
            lang.menuPic = ''
          })
        }

        // 强制重置langCode为默认语言
        if (state.langDic && state.langDic.length) {
          state.menu.langCode = state.langDic[0].value
          state.langCode = state.langDic[0].value
        }

        // 强制使用默认语言的数据填充表单，防止使用非默认语言的数据保存
        if (state.menu.langs && state.menu.langs.length) {
          const defaultLangCode = state.langDic[0].value
          const defaultLang = state.menu.langs.find(
            l => l.langCode === defaultLangCode
          )
          if (defaultLang) {
            state.menu.menuName = defaultLang.menuName
            state.menu.menuPic = defaultLang.menuPic
            state.menu.externalMaterialId = defaultLang.externalMaterialId
            state.menu.externalMaterialSource =
              defaultLang.externalMaterialSource
          }
        }

        state.uploadErr = null
        if (
          state.langDic.find(item =>
            ['', null, undefined].includes(item.menuName)
          )
        ) {
          message.warning('名称不能为空！')
          return
        }
        if (!state.menu.menuCategory !== 2) {
          if (state?.menu?.menuUrl) {
            if (
              state.menu.menuUrl.match(/\?/g) &&
              state.menu.menuUrl.match(/\?/g).length >= 2
            ) {
              message.error('配置错误，地址链接只能包含一个?，请修改')
              return
            }
          }
        }
        if (state.menu.urlType === 0 && state?.menu?.menuUrl) {
          if (state.menu.menuUrl.indexOf('?') !== 0) {
            message.error('首字符以"?"开头')
            return
          }
          if (state.menu.menuUrl.indexOf('??') === 0) {
            message.error('仅以一个"?"开头')
            return
          }
        }
        if (state.menu.menuCategory === 2) {
          const piclLength = state.menu.langs[0]?.menuPicDtos?.length
          const hasNullUrl = state.menu.langs.some(item =>
            item.menuPicDtos.some(menuItem => menuItem.picUrl === null)
          )
          const hasNullName = state.menu.langs.some(item =>
            item.menuPicDtos.some(
              menuItem =>
                menuItem.urlType === 0 &&
                ['', null, undefined].includes(menuItem.colId)
            )
          )
          let msg = false
          state.menu.langs.forEach(item => {
            item.menuPicDtos?.forEach(pic => {
              if (pic.urlType === 0) {
                console.log('pic', pic)
                if (pic.menuUrl && pic.menuUrl.indexOf('?') !== 0) {
                  msg = true
                  return message.warning('链接首字符以"?"开头')
                }
              }
            })
          })
          if (msg) {
            return
          }
          if (hasNullName) {
            return message.warning('collectionID不能为空！')
          }
          if (hasNullUrl) {
            message.warning('图片不能为空！')
            return
          }
          if (!piclLength) {
            message.warning('请检查图片数量！')
            return
          }
        }
        if (
          state.postParams.navType === 'header' &&
          ((state.postParams.navStyle === 1 &&
            state.postParams.subChannel === 2 &&
            (menuType === 2 || menuType === 4)) ||
            (state.postParams.subChannel === 1 &&
              state.menu.canImg &&
              menuType === 2))
        ) {
          if (
            state.menu.menuCategory === 1 &&
            state.langDic.find(item => !item.menuPic)
          ) {
            message.warning('图片不能为空！')
            return
          } else if (state.menu.menuCategory === 2) {
            // const img = state.menu.langs.every(
            //   (item, _, array) =>
            //     item.menuPicDtos?.length === array[0].menuPicDtos?.length
            // )
            const isValid = state.menu.langs.every((item, _, array) => {
              const length = item.menuPicDtos?.length || 0
              return length === array[0].menuPicDtos?.length && length > 0
            })
            const isPicEmpty = state.menu.langs.every(
              item => !item.menuPicDtos.every(item => !item.menuPic)
            )
            console.log('isValid', isValid, isPicEmpty)
            if (!isValid) {
              return message.warning('请检查图片数量！')
            }
          }
        }
        if (state.menu?.urlType - 0 === 0 && state.route.query?.id) {
          // if (state.menu?.menuUrl?.indexOf('?') > -1) {
          //   const splitArr = state.menu?.menuUrl?.split('?')
          //   state.menu.addonBefore = splitArr?.[0] ?? ''
          //   state.menu.menuUrl = splitArr?.[1] ?? ''
          // } else {
          //   if (!state.menu?.menuUrl) {
          //     state.menu.addonBefore = !state.menu?.menuUrl
          //       ? state.menu?.addonBefore
          //       : !state.menu?.menuUrl
          //     state.menu.menuUrl = ''
          //   }
          // }
          //state.menu.menuUrl
          //   (!state.menu.addonBefore ? '' : state.menu.addonBefore) +
          //   (!state.menu.menuUrl ? '' : '?' + state.menu.menuUrl)
        }

        // state.menu.addonBefore = ''
        let checkIndex = state.checkIndex
        let sonCheckIndex = state.sonCheckIndex
        let gsCheckIndex = state.gsCheckIndex
        let fourIndex = state.fourIndex
        if (
          state.postParams.subChannel === -1 &&
          menuType === 2 &&
          state.menu.menuModule === 1 &&
          state.menu.menuCategory === 1
        ) {
          let menuPic = false
          state.menu.langs.forEach(item => {
            if (!item.menuPic) {
              menuPic = true
            }
          })
          if (menuPic) {
            return message.warning('图片不能为空！')
          }
        }
        if (
          state.postParams.subChannel === -1 &&
          menuType === 2 &&
          state.menu.urlType === 0
        ) {
          state.menu.menuUrl = `${
            state.menu.addonBefore ? state.menu.addonBefore : ''
          }${state.menu.menuUrl || ''}`
        }
        if (state.postParams.subChannel - 0 === 1) {
          const isImageOrHasPic =
            state.postParams.navStyle - 0 === 1 ||
            state.menu.layout - 0 !== 0 ||
            !!state.menu.canImg ||
            !!state.menu.menuPic
          if (menuType === 1) {
            state.menu.menuType = isImageOrHasPic ? 102 : 100
          } else if ([2, 3].includes(menuType)) {
            state.menu.menuType = isImageOrHasPic ? 101 : 100
          }
        }
        if (state.postParams.subChannel - 0 === 2) {
          if (menuType === 3) {
            if (state.postParams.subChannel - 0 === 2) {
              state.menu.menuType = state.menu.imgStyle - 0 === 3 ? 101 : 100
            }
          }
          if (menuType === 4) {
            const fourParent = state.menuList[state.checkIndex]?.menuList?.[
              state.sonCheckIndex
            ]?.menuList?.[state.gsCheckIndex] || {
              menuList: [],
              imgStyle: 0
            }
            if (fourParent.imgStyle - 0 === 3) {
              state.menu.menuType = 101
            }
          }
          if (menuType === 2 && state.menu.menuCategory === 1) {
            state.menu.menuType = 102
          }
        }
        let targetIndex = gsCheckIndex
        switch (menuType) {
          case 1: // 编辑一级导航
            if (state.menuList[checkIndex]) {
              state.menuList.splice(checkIndex, 1, { ...state.menu })
            }
            state.postParams.modify = true
            break
          case 2:
            if (state.menu.menuCategory === 2) {
              state.menu.langs.forEach(item => {
                item.menuPicDtos?.forEach(pic => {
                  if (pic.urlType === 0) {
                    pic.menuUrl = `${pic.addonBefore ? pic.addonBefore : ''}${
                      pic.menuUrl
                    }`
                  }
                })
              })
            }
            state.menuList[checkIndex].menuList[sonCheckIndex] = {
              ...state.menu
            }
            break
          case 3:
            if (
              state.postParams.subChannel === -1 &&
              state.menuList[checkIndex]?.subMenuType === 1 &&
              +state.menu.menuType === 101
            ) {
              if (
                state.langDic.some(
                  item =>
                    !item.menuPicDtos ||
                    item.menuPicDtos.length === 0 ||
                    item.menuPicDtos.some(pic => !pic.picUrl)
                )
              ) {
                return message.warning('banner图片不能为空！')
              }
              let hasError = false
              state.langDic.forEach(lang => {
                if (lang.menuPicDtos) {
                  lang.menuPicDtos.forEach(pic => {
                    if (!pic.materialTitle) {
                      if (!hasError) message.warning('标题名称不能为空！')
                      hasError = true
                    }
                  })
                }
              })
              if (hasError) return

              const siblings =
                state.menuList[checkIndex].menuList[sonCheckIndex].menuList ||
                []
              if (state.menu.bannerType === 1) {
                state.menu.menuCategory = 2
                const hasHeader = siblings.some(
                  (item, idx) =>
                    idx !== gsCheckIndex &&
                    +item.menuType === 101 &&
                    item.bannerType === 1
                )
                if (hasHeader) {
                  return message.warning('只能添加一个头部！')
                }
              }
              if (state.menu.bannerType === 2) {
                state.menu.menuCategory = 2
                const hasFooter = siblings.some(
                  (item, idx) =>
                    idx !== gsCheckIndex &&
                    +item.menuType === 101 &&
                    item.bannerType === 2
                )
                if (hasFooter) {
                  return message.warning('只能添加一个底部！')
                }
              }
              state.menu.langs.forEach(item => {
                item.menuPicDtos?.forEach(pic => {
                  if (pic.urlType === 0) {
                    pic.menuUrl = `${pic.addonBefore ? pic.addonBefore : ''}${
                      pic.menuUrl
                    }`
                  }
                })
              })
            }
            if (
              state.postParams.subChannel === -1 &&
              +state.menu.menuType === 100
            ) {
              state.menu.menuCategory = 1
              if (state.menu.urlType === 0) {
                const query = (state.menu.menuUrl || '').split('?')[1]
                state.menu.menuUrl = `${
                  state.menu.addonBefore ? state.menu.addonBefore : ''
                }${query ? '?' + query : ''}`
              } else {
                state.menu.menuUrl = state.menu.addonBefore
                  ? state.menu.addonBefore
                  : state.menu.menuUrl
              }
            }
            if (
              state.postParams.subChannel === -1 &&
              +state.menu.menuType === 101
            ) {
              // Recombination for banner menus is handled in the menuPicDtos loop above
              // But we still need to handle the case where menuType=101 but it's not a banner (shouldn't happen for L3 but just in case)
              state.menu.menuUrl = state.menu.addonBefore
                ? state.menu.addonBefore
                : state.menu.menuUrl
              const list =
                state.menuList[checkIndex].menuList[sonCheckIndex].menuList ||
                []
              const matchIndex = list.findIndex(
                item =>
                  +item.menuType === 101 &&
                  item.bannerType === state.menu.bannerType
              )
              if (matchIndex !== -1) {
                targetIndex = matchIndex
              }
            }
            state.menuList[checkIndex].menuList[sonCheckIndex].menuList[
              targetIndex
            ] = { ...state.menu }
            if (state.postParams.subChannel === -1) {
              const list =
                state.menuList[checkIndex].menuList[sonCheckIndex].menuList
              state.menuList[checkIndex].menuList[
                sonCheckIndex
              ].menuList = sortAppLevel3(list)
            }
            break
          case 4:
            if (state.postParams.subChannel === -1) {
              if (state.menu.urlType === 0) {
                const query = (state.menu.menuUrl || '').split('?')[1]
                state.menu.menuUrl = `${
                  state.menu.addonBefore ? state.menu.addonBefore : ''
                }${query ? '?' + query : ''}`
              } else {
                state.menu.menuUrl = state.menu.addonBefore
                  ? state.menu.addonBefore
                  : state.menu.menuUrl
              }
            }
            state.menuList[checkIndex].menuList[sonCheckIndex].menuList[
              gsCheckIndex
            ].menuList[fourIndex] = { ...state.menu }
            break
        }
        state.drawVisible = false
        if (state.postParams.subChannel === -1) {
          // state.resetMenu.urlType = 1
        }

        state.menu = { ...state.resetMenu, langs: state.initLangs() }
        message.success('操作成功！')
      },
      closeDraw: () => {
        state.drawVisible = false
        if (state.postParams.subChannel === -1) {
          // state.resetMenu.urlType = 1
        }
        state.menu = { ...state.resetMenu, langs: state.initLangs() }
        if (state.langDic && state.langDic.length) {
          state.langCode = state.langDic[0].value
        }
      },
      changeLayout: () => {
        let menuList = state.menu.menuList
        let urlType = state.postParams.subChannel === -1 ? 1 : 0
        const createDefaultItem = () => ({
          colId: null,
          id: null,
          layout: 0, // 子菜单样式布局，0-纯文本，1-单图，2-双图
          menuColor: '#000000',
          menuColorType: 1,
          fromColor: '#000000',
          toColor: '#000000',
          menuName: null,
          menuPic: null,
          menuType: 101, // 100 纯文本 101 图文
          menuUrl: null,
          parentId: null,
          urlType, // 0-collection链接，1-普通链接
          menuList: [],
          canRemove: true,
          raceLock: 0,
          langs: []
        })

        const maxText =
          state.menu.layout === 2 || state.menu.layout === 4
            ? 3
            : state.menu.layout === 1 || state.menu.layout === 3
            ? 4
            : 5
        const rebuilt = []
        let textCount = 0
        for (const it of menuList) {
          // 跳过旧的图文占位
          if (it.menuType - 0 === 101) continue
          // 保留轮播/广告位原始位置
          if (it.menuCategory - 0 === 2) {
            rebuilt.push(it)
            continue
          }
          // 普通二级（纯文/其它），按最大数量保留原顺序
          if (textCount < maxText) {
            rebuilt.push(it)
            textCount++
          }
        }
        if (state.menu.layout === 0) {
          state.menu.menuList = rebuilt
        } else if (state.menu.layout === 1 || state.menu.layout === 3) {
          state.menu.menuList = [...rebuilt, createDefaultItem()]
        } else if (state.menu.layout === 2 || state.menu.layout === 4) {
          state.menu.menuList = [
            ...rebuilt,
            createDefaultItem(),
            createDefaultItem()
          ]
        }
      },
      addMenu: menuType => {
        if (state.langDic && state.langDic.length) {
          state.langCode = state.langDic[0].value
        }
        state.menu.langs = state.langDic.map(item => ({
          ...item,
          langCode: item.value,
          langLabel: item.label,
          menuPicDtos: item.menuPicDtos || []
        }))

        // Clear menuPic if it is a banner type (App Level 3 Banner)
        if (
          state.postParams.subChannel === -1 &&
          state.menuList[state.checkIndex]?.subMenuType === 1 &&
          +state.menu.menuType === 101
        ) {
          state.menu.langs.forEach(lang => {
            lang.menuPic = ''
          })
        }

        if (state.menu.langs && state.menu.langs.length) {
          state.menu.menuName = state.menu.langs[0].menuName
          state.menu.langCode = state.menu.langs[0].langCode
          state.menu.menuPic = state.menu.langs[0].menuPic
        }
        state.menu.langCode = state.langDic[0].value
        if (
          state.langDic.find(item =>
            ['', null, undefined].includes(item.menuName)
          )
        ) {
          message.warning('名称不能为空！')
          return
        }
        if (state?.menu?.menuUrl) {
          if (
            state.menu.menuUrl.match(/\?/g) &&
            state.menu.menuUrl.match(/\?/g).length >= 2
          ) {
            message.error('配置错误，地址链接只能包含一个?，请修改')
            return
          }
        }
        if (state.menu.urlType === 0 && state?.menu?.menuUrl) {
          if (state.menu.menuUrl.indexOf('?') !== 0) {
            message.error('首字符以"?"开头')
            return
          }
          if (state.menu.menuUrl.indexOf('??') === 0) {
            message.error('仅以一个"?"开头')
            return
          }
        }
        if (state.menu.menuCategory === 2) {
          const piclLength = state.menu.langs[0]?.menuPicDtos?.length
          const hasNullUrl = state.menu.langs.some(item =>
            item.menuPicDtos.some(menuItem => menuItem.picUrl === null)
          )
          const hasNullName = state.menu.langs.some(item =>
            item.menuPicDtos.some(
              menuItem =>
                menuItem.urlType === 0 &&
                ['', null, undefined].includes(menuItem.colId)
            )
          )
          let msg = false
          state.menu.langs.forEach(item => {
            item.menuPicDtos?.forEach(pic => {
              if (pic.urlType === 0) {
                if (pic.menuUrl && pic.menuUrl.indexOf('?') !== 0) {
                  msg = true
                  return message.warning('链接首字符以"?"开头')
                }
              }
            })
          })
          if (msg) {
            return
          }
          if (hasNullName) {
            return message.warning('collectionID不能为空！')
          }
          if (hasNullUrl) {
            message.warning('图片不能为空！')
            return
          }
          if (!piclLength) {
            message.warning('请检查图片数量！')
            return
          }
        }
        if (
          state.postParams.navType === 'header' &&
          ((state.postParams.navStyle === 1 &&
            state.postParams.subChannel === 2 &&
            (menuType === 2 || menuType === 4)) ||
            (state.postParams.subChannel === 1 &&
              state.menu.canImg &&
              menuType === 2))
        ) {
          if (
            state.menu.menuCategory === 1 &&
            state.langDic.find(item => !item.menuPic)
          ) {
            message.warning('图片不能为空！')
            return
          } else if (state.menu.menuCategory === 2) {
            // const img = state.menu.langs.every(
            //   (item, _, array) =>
            //     item.menuPicDtos?.length === array[0].menuPicDtos?.length
            // )
            // const isValid = state.menu.langs.every((item, _, array) => {
            //   const length = item.menuPicDtos?.length || 0
            //   return length === array[0].menuPicDtos?.length && length > 0
            // })
            // const isPicEmpty = state.menu.langs.every(
            //   item => !item.menuPicDtos.every(item => !item.menuPic)
            // )
            // console.log('isValid', isValid, isPicEmpty)
            // if (!isValid || !isPicEmpty) {
            //   return message.warning('请检查图片数量！')
            // }
          }
        }
        // console.log('state.menu', state.menu)
        // if (state.menu.urlType - 0 === 0) {
        //   state.menu.menuUrl =
        //     (!state.menu.addonBefore ? '' : state.menu.addonBefore) +
        //     (!state.menu.menuUrl ? '' : '?' + state.menu.menuUrl)
        // }
        // state.menu.addonBefore = ''
        let perMenuList = []
        let checkIndex = state.checkIndex
        let sonCheckIndex = state.sonCheckIndex
        let gsCheckIndex = state.gsCheckIndex
        if (
          state.postParams.subChannel === -1 &&
          menuType === 2 &&
          state.menu.menuModule === 1 &&
          state.menu.menuCategory === 1
        ) {
          let menuPic = false
          state.menu.langs.forEach(item => {
            if (!item.menuPic) {
              menuPic = true
            }
          })
          if (menuPic) {
            return message.warning('图片不能为空！')
          }
        }
        if (
          state.postParams.subChannel === -1 &&
          menuType === 2 &&
          state.menu.urlType === 0
        ) {
          state.menu.menuUrl = `${
            state.menu.addonBefore ? state.menu.addonBefore : ''
          }${state.menu.menuUrl || ''}`
        }
        if (state.menu.menuModule === 2) {
          let menuPic = false
          state.menu.langs.forEach(item => {
            if (!item.menuPic) {
              menuPic = true
            }
          })
          if (menuPic) {
            return message.warning('图片不能为空！')
          }
        }
        if (
          state.postParams.subChannel === -1 &&
          menuType === 2 &&
          state.menu.urlType === 0
        ) {
          state.menu.menuUrl = `${
            state.menu.addonBefore ? state.menu.addonBefore : ''
          }${state.menu.menuUrl || ''}`
        }
        if (state.postParams.subChannel - 0 === 1) {
          const isImageOrHasPic =
            state.postParams.navStyle - 0 === 1 ||
            state.menu.layout - 0 !== 0 ||
            !!state.menu.canImg ||
            !!state.menu.menuPic
          if (menuType === 1) {
            state.menu.menuType = isImageOrHasPic ? 102 : 100
          } else if ([2, 3].includes(menuType)) {
            state.menu.menuType = isImageOrHasPic ? 101 : 100
          }
        }
        if (state.postParams.subChannel - 0 === 2) {
          if (menuType === 3 && state.menu.imgStyle - 0 === 3) {
            state.menu.menuType = 101
          }
          if (menuType === 4) {
            const fourParent = state.menuList[state.checkIndex]?.menuList?.[
              state.sonCheckIndex
            ]?.menuList?.[state.gsCheckIndex] || {
              menuList: [],
              imgStyle: 0
            }
            if (fourParent.imgStyle - 0 === 3) {
              state.menu.menuType = 101
            }
          }
          if (menuType === 2 && state.menu.menuCategory === 1) {
            state.menu.menuType = 102
          }
        }
        switch (menuType) {
          case 1: // 添加一级导航
            state.menuList = [...state.menuList, { ...state.menu }]
            if (state.checkIndex === null && state.menuList.length) {
              state.checkIndex = 0
            }
            if (!state.checkIndex && state.menuList.length) {
              state.checkIndex = 0
            }
            state.postParams.modify = true
            break
          case 2: // 添加二级导航
            // PC端：普通二级菜单最多5个（不含图文占位与轮播）
            if (
              state.postParams.navType === 'header' &&
              state.postParams.subChannel === 1
            ) {
              const secondCount = (
                state.menuList[checkIndex].menuList || []
              ).filter(item => item.menuCategory !== 2).length
              if (secondCount >= 5) {
                message.error('二级菜单不可超过5个，请确认')
                return
              }
            }
            if (state.menu.menuCategory === 2) {
              state.menu.langs.forEach(item => {
                item.menuPicDtos?.forEach(pic => {
                  if (pic.urlType === 0) {
                    pic.menuUrl = `${pic.addonBefore ? pic.addonBefore : ''}${
                      pic.menuUrl
                    }`
                  }
                })
              })
              if (state.menu.bannerType === 1) {
                const findHeader = state.menuList[checkIndex].menuList.filter(
                  item => item.bannerType === 1 && item.menuCategory === 2
                )
                console.log('findHeader', findHeader)
                if (findHeader.length) {
                  message.warning('只能添加一个头部轮播图！')
                  return
                }
                if (!state.menuList[checkIndex].menuList?.length) {
                  state.menuList[checkIndex].menuList = [{ ...state.menu }]
                } else {
                  state.menuList[checkIndex].menuList.unshift({
                    ...state.menu
                  })
                }
              } else {
                const findFotter = state.menuList[checkIndex].menuList.filter(
                  item => item.bannerType === 2 && item.menuCategory === 2
                )
                if (findFotter.length) {
                  message.warning('只能添加一个尾部轮播图！')
                  return
                }
                if (!state.menuList[checkIndex].menuList?.length) {
                  state.menuList[checkIndex].menuList = [{ ...state.menu }]
                } else {
                  state.menuList[checkIndex].menuList = [
                    ...state.menuList[checkIndex].menuList,
                    { ...state.menu }
                  ]
                }
              }
              state.drawVisible = false
              if (state.postParams.subChannel === -1) {
                // state.resetMenu.urlType = 1
                state.resetMenu.subMenuType = 1
              }
              // state.postParams = { ...state.resetPostParams, ...state.route.query }
              state.menu = { ...state.resetMenu, langs: state.initLangs() }
              message.success('操作成功！')
              return
            }
            if (state.postParams.navType === 'footer') {
              state.menuList[checkIndex].menuList = [
                ...state.menuList[checkIndex].menuList,
                {
                  ...state.menu
                }
              ]
            } else {
              if (
                !state.menuList[checkIndex].layout ||
                state.menuList[checkIndex].layout - 0 === 0
              ) {
                state.menuList[checkIndex].menuList = [
                  ...state.menuList[checkIndex].menuList,
                  {
                    ...state.menu,
                    menuList: state.menu.menuList || []
                  }
                ]
              } else if (state.menuList[checkIndex].layout - 0 === 1) {
                let menuList = [...state.menuList[checkIndex].menuList]
                menuList.splice(menuList.length - 1, 0, { ...state.menu })
                state.menuList[checkIndex].menuList = [...menuList]
              } else if (state.menuList[checkIndex].layout - 0 === 3) {
                let menuList = [...state.menuList[checkIndex].menuList]
                menuList.splice(menuList.length - 1, 0, { ...state.menu })
                state.menuList[checkIndex].menuList = [...menuList]
              } else if (state.menuList[checkIndex].layout - 0 === 2) {
                let menuList = [...state.menuList[checkIndex].menuList]
                menuList.splice(menuList.length - 2, 0, { ...state.menu })
                state.menuList[checkIndex].menuList = [...menuList]
              } else if (state.menuList[checkIndex].layout - 0 === 4) {
                let menuList = [...state.menuList[checkIndex].menuList]
                menuList.splice(menuList.length - 2, 0, { ...state.menu })
                state.menuList[checkIndex].menuList = [...menuList]
              }
              if (
                state.postParams.navStyle === 1 ||
                state.postParams.navStyle === 0
              ) {
                state.sonCheckIndex = 0
              }
            }
            break
          case 3: // 添加三级导航
            perMenuList =
              state.menuList[checkIndex].menuList[sonCheckIndex].menuList || []

            if (
              state.postParams.subChannel === -1 &&
              [2, 3].includes(state.menuList[checkIndex]?.subMenuType)
            ) {
              return message.warning('当前菜单类型不支持添加三级菜单')
            }

            if (
              state.postParams.subChannel === -1 &&
              state.menuList[checkIndex]?.subMenuType === 1 &&
              +state.menu.menuType === 101
            ) {
              if (
                state.langDic.some(
                  item =>
                    !item.menuPicDtos ||
                    item.menuPicDtos.length === 0 ||
                    item.menuPicDtos.some(pic => !pic.picUrl)
                )
              ) {
                return message.warning('banner图片不能为空！')
              }
              let hasError = false
              state.langDic.forEach(lang => {
                if (lang.menuPicDtos) {
                  lang.menuPicDtos.forEach(pic => {
                    if (!pic.materialTitle) {
                      if (!hasError) message.warning('标题名称不能为空！')
                      hasError = true
                    }
                  })
                }
              })
              if (hasError) return

              if (state.menu.bannerType === 1) {
                state.menu.menuCategory = 2
                const hasHeader = perMenuList.some(
                  item => +item.menuType === 101 && item.bannerType === 1
                )
                if (hasHeader) {
                  return message.warning('只能添加一个头部！')
                }
              }
              if (state.menu.bannerType === 2) {
                state.menu.menuCategory = 2
                const hasFooter = perMenuList.some(
                  item => +item.menuType === 101 && item.bannerType === 2
                )
                if (hasFooter) {
                  return message.warning('只能添加一个底部！')
                }
              }
            }

            if (
              state.postParams.subChannel === -1 &&
              +state.menu.menuType === 100
            ) {
              state.menu.menuCategory = 1
            }
            if (state.postParams.subChannel === -1) {
              // Recombine URL for text menu (Level 3 App)
              if (state.menu.urlType === 0) {
                const query = (state.menu.menuUrl || '').split('?')[1]
                state.menu.menuUrl = `${
                  state.menu.addonBefore ? state.menu.addonBefore : ''
                }${query ? '?' + query : ''}`
              } else {
                state.menu.menuUrl = state.menu.addonBefore
                  ? state.menu.addonBefore
                  : state.menu.menuUrl
              }
            }
            perMenuList = [...perMenuList, state.menu]
            if (state.postParams.subChannel === -1) {
              perMenuList = sortAppLevel3(perMenuList)
            }
            state.menuList[checkIndex].menuList[sonCheckIndex].menuList = [
              ...perMenuList
            ]
            state.menu.langs.forEach(item => {
              item.menuPicDtos?.forEach(pic => {
                if (pic.urlType === 0) {
                  pic.menuUrl = `${pic.addonBefore ? pic.addonBefore : ''}${
                    pic.menuUrl
                  }`
                }
              })
            })
            break
          case 4:
            // M端三级为banner多图时，四级最多5个
            if (
              state.postParams.subChannel === 2 &&
              state.menuList[checkIndex]?.menuList?.[sonCheckIndex]?.menuList?.[
                gsCheckIndex
              ]?.imgStyle === 3 &&
              (state.menuList[checkIndex].menuList[sonCheckIndex].menuList[
                gsCheckIndex
              ].menuList?.length || 0) >= 5
            ) {
              message.error('四级菜单最多支持5个')
              break
            }
            if (state.postParams.subChannel === -1) {
              if (state.menu.urlType === 0) {
                const query = (state.menu.menuUrl || '').split('?')[1]
                state.menu.menuUrl = `${
                  state.menu.addonBefore ? state.menu.addonBefore : ''
                }${query ? '?' + query : ''}`
              } else {
                state.menu.menuUrl = state.menu.addonBefore
                  ? state.menu.addonBefore
                  : state.menu.menuUrl
              }
            }
            perMenuList =
              state.menuList[checkIndex].menuList[sonCheckIndex].menuList[
                gsCheckIndex
              ].menuList
            perMenuList = [...perMenuList, state.menu]
            state.menuList[checkIndex].menuList[sonCheckIndex].menuList[
              gsCheckIndex
            ].menuList = [...perMenuList]
            break
        }
        state.drawVisible = false
        if (state.postParams.subChannel === -1) {
          // state.resetMenu.urlType = 1
        }
        if (state.menuList[checkIndex]?.menuCategory === 1) {
          const fotter = state.menuList[checkIndex].menuList.filter(
            item => item.bannerType === 2
          )
          const header = state.menuList[checkIndex].menuList.filter(
            item => item.bannerType === 1
          )
          const zhengce = state.menuList[checkIndex].menuList.filter(
            item => item.menuModule === 2
          )
          state.menuList[checkIndex].menuList = [
            ...header,
            ...state.menuList[checkIndex].menuList.filter(
              item =>
                item.bannerType !== 2 &&
                item.menuModule !== 2 &&
                item.bannerType !== 1
            ),
            ...fotter,
            ...zhengce
          ]
        }
        // state.postParams = { ...state.resetPostParams, ...state.route.query }
        state.menu = { ...state.resetMenu, langs: state.initLangs() }
        message.success('操作成功！')
      },
      menuList: [],
      colList: [],
      getColList: () => {
        nav_col_list_post_(state)
      },
      menu: {},
      resetMenu: {
        colId: null,
        id: null,
        layout: 0, // 子菜单样式布局，0-纯文本，1-单图，2-双图
        menuColor: '#000000',
        menuColorType: 1,
        fromColor: '#000000',
        toColor: '#000000',
        menuName: null,
        menuPic: null,
        menuType: '100', // 100 纯文本 101 图文
        bannerType: 1,
        menuUrl: '',
        parentId: null,
        urlType: 0, // 0-collection链接，1-普通链接
        menuList: [],
        addonBefore: '',
        raceLock: 0,
        showName: 0,
        imgStyle: 0,
        subMenuType: 1
      },
      resetPostParams: {
        navName: null,
        navType: 'header',
        subChannel: 1, // 适用终端 1 pc 2 m
        navStyle: 0,
        menuList: [],
        versionId: 1
      },
      formState: {},
      handleReset() {
        state.formState = {}
        state.addonPagination.pageNum = 1
        state.getColList()
      },
      handleQuery() {
        state.addonPagination.pageNum = 1
        state.getColList()
      },
      uploadImgInfo: {
        secondLevel: {
          tip:
            '支持png、jpg、gif等格式上传；图片的尺寸为44*44，且大小在5M以内；',
          width: 44,
          height: 44,
          size: 5120
        },
        fourBanner1: {
          tip:
            '支持png、jpg、gif等格式上传；图片的尺寸比例为300*120，且大小在5M以内；',
          width: 300,
          height: 120,
          size: 5120
        },
        fourBanner2: {
          tip:
            '支持png、jpg、gif等格式上传；图片的尺寸比例为146*60，且大小在5M以内；',
          width: 146,
          height: 60,
          size: 5120
        },
        fourBanner3: {
          tip:
            '支持png、jpg、gif等格式上传；图片的尺寸为60*60，且大小在5M以内；',
          width: 60,
          height: 60,
          size: 5120
        },
        fourBanner4: {
          tip: '支持png格式上传；图片的尺寸为48*48，且大小在5M以内；',
          width: 48,
          height: 48,
          size: 5120
        }
      },
      setImgUrl: item => {
        state.menu.menuPic = item
        state.menu.externalMaterialId = ''
        state.menu.externalMaterialSource = ''
        state.menu.langs = state.menu.langs.map(v => {
          if (v.langCode === state.langCode) {
            v.menuPic = item
            v.externalMaterialId = ''
            v.externalMaterialSource = ''
          }
          return v
        })
        state.langDic = state.langDic.map(v => {
          if (v.langCode === state.langCode) {
            v.externalMaterialId = ''
            v.externalMaterialSource = ''
          }
          return v
        })
      },
      navStyleChange: e => {
        state.menuList = []
        if (state.dataAll?.length === 2) {
          state.dataAll[1].navStyle = e.target.value
        }
      },
      removeExternalMaterialInfo: menuList => {
        if (!Array.isArray(menuList)) return menuList
        return menuList.map(item => {
          // 删除当前项的externalMaterialId和externalMaterialSource
          if (
            Object.prototype.hasOwnProperty.call(item, 'externalMaterialId')
          ) {
            delete item.externalMaterialId
          }
          if (
            Object.prototype.hasOwnProperty.call(item, 'externalMaterialSource')
          ) {
            delete item.externalMaterialSource
          }
          // 一级/当前项 menuPic 为空则清理所有语言的图片与素材编号
          if (
            !item.menuPic &&
            Array.isArray(item.langs) &&
            item.langs.length > 0
          ) {
            item.langs.forEach(lang => {
              lang.menuPic = null
              if (
                Object.prototype.hasOwnProperty.call(lang, 'externalMaterialId')
              ) {
                delete lang.externalMaterialId
              }
              if (
                Object.prototype.hasOwnProperty.call(
                  lang,
                  'externalMaterialSource'
                )
              ) {
                delete lang.externalMaterialSource
              }
            })
          }
          // 处理langs数组中menuPic为空的情况
          if (Array.isArray(item.langs) && item.langs.length > 0) {
            item.langs.forEach(lang => {
              if (!lang.menuPic) {
                if (
                  Object.prototype.hasOwnProperty.call(
                    lang,
                    'externalMaterialId'
                  )
                ) {
                  delete lang.externalMaterialId
                }
                if (
                  Object.prototype.hasOwnProperty.call(
                    lang,
                    'externalMaterialSource'
                  )
                ) {
                  delete lang.externalMaterialSource
                }
              }
            })
          }
          // 处理子菜单
          if (Array.isArray(item.menuList) && item.menuList.length > 0) {
            item.menuList = state.removeExternalMaterialInfo(item.menuList)
          }
          return item
        })
      }
    })

    watch(
      () => state.drawVisible,
      () => {
        if (state.langDic && state.langDic.length && state.drawVisible) {
          state.langCode = state.langDic[0].value
        }
      },
      {
        deep: true,
        immediate: true
      }
    )

    // watchEffect(() => {
    //   if (state.menu.menuPic) {
    //     console.log('state.menu.menuPic', state.menu)
    //     state.menu.langs = state.menu.langs.map(v => {
    //       if (v.langCode === state.langCode) {
    //         v.menuPic = state.menu.menuPic
    //       }
    //       return v
    //     })
    //   }
    // })

    watch(
      () => state.langCode,
      () => {
        if (state.menu.langs && state.menu.langs.length) {
          state.menu.langs.map(v => {
            if (String(v.langCode || v.value) === String(state.langCode)) {
              const {
                menuName,
                menuPic,
                externalMaterialId,
                externalMaterialSource
              } = v
              state.menu.menuName = menuName
              state.menu.menuPic = menuPic
              state.menu.externalMaterialId = externalMaterialId
              state.menu.externalMaterialSource = externalMaterialSource
            }
          })
        }
      },
      {
        deep: true,
        immediate: true
      }
    )

    watch(
      [
        () => state.menu.menuName,
        () => state.menu.menuPic,
        () => state.menu.externalMaterialId,
        () => state.menu.externalMaterialSource
      ],
      () => {
        state.menu.langCode = state.langCode
        if (state.menu.langs && state.menu.langs.length && state.langCode) {
          state.menu.langs.map(v => {
            if (String(v.langCode || v.value) === String(state.langCode)) {
              v.menuName = state.menu.menuName
              v.menuPic = state.menu.menuPic
              v.externalMaterialId = state.menu.externalMaterialId
              v.externalMaterialSource = state.menu.externalMaterialSource
              return v
            }
          })
        }
        if (state.langDic && state.langDic.length && state.langCode) {
          state.langDic.map(v => {
            if (String(v.langCode || v.value) === String(state.langCode)) {
              v.menuName = state.menu.menuName
              v.menuPic = state.menu.menuPic
              v.externalMaterialId = state.menu.externalMaterialId
              v.externalMaterialSource = state.menu.externalMaterialSource
              return v
            }
          })
        }
      },
      {
        deep: true,
        immediate: true
      }
    )

    // watch(
    //   () => [state.menu.menuName, state.menu.menuPic],
    //   ([name, pic]) => {
    //     console.log('name,pic', name, pic)
    //     state.menu.langCode = state.langCode
    //     if (state.menu.langs?.length && state.langCode) {
    //       if (state.menu.langCode === state.langCode) {
    //         const langs = state.menu.langs.map(v => {
    //           v.menuName = state.menu.menuName
    //           v.menuPic = state.menu.menuPic
    //           return v
    //         })
    //         state.menu.langs = langs
    //       }
    //       console.log('state.menu', state.menu)
    //     }
    //   },
    //   {
    //     deep: true,
    //     immediate: true
    //   }
    // )
    provide('initState', state)
    onMounted(() => {
      state.postParams = { ...state.resetPostParams, ...state.route.query }
      state.common_lang_get()
      nav_v2_people_types_get_()
      // terminalId 1 pc 2 App
      if (state.postParams.terminalId - 0 === 2) {
        state.postParams.navType = 'header'
        state.postParams.navStyle = 1
        state.postParams.subChannel = -1
      }
      if (state.postParams.id) {
        state.getDetail()
      }
    })

    return {
      ...toRefs(state),
      typeOptions: [
        {
          label: 'header',
          value: 'header'
        },
        {
          label: 'footer',
          value: 'footer'
        }
      ],
      terminalOptions: [
        {
          label: 'PC端',
          value: 1
        },
        {
          label: 'M端',
          value: 2
        }
      ],
      styleOptions: [
        {
          label: '纯文字导航',
          value: 0
        }
        //,
        // {
        //   label: '带图导航',
        //   value: 1
        // }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.editBread {
  background: #ffffff;
  margin: 15px;
  padding: 15px 20px;
}

.EditContainer {
  background: #ffffff;
  margin: 15px;
  padding: 15px 20px;
}

.bottomBar {
  position: fixed;
  left: 0;
  bottom: 0;
  background: #ffffff;
  z-index: 999;
  padding: 10px;
  width: calc(100%);
  border-top: 1px solid #f8f8f8;
}
</style>
